import React, { useEffect, useState } from 'react';
import {Button, Pagination, Popconfirm, Modal, Form, Input, Switch, message  , InputNumber} from 'antd';

import Breadcrumbs from '../../../common/breadcrumb/Breadcrumbs';
import Loader from '../../../common/loader/Loader';
import { getBonusTxnCap  , deleteBonusTxnCap , updateBonusTxnCap ,addBonusTxnCap} from '../../../api/login/Login';


const breadCrumbsTitle = {
    id: '1',
    title_1: 'Bonus Tranaction Master',
    path_1: '/admin/transaction-cap',
    title_2: 'Transaction Cap',
  };

const BonusTranactionCap = () => {
      const [loading, setLoading] = useState(false);
        const [data, setData] = useState([]);
        const [pageNo, setPageNo] = useState(1); 
        const [totalData, setTotalData] = useState(0); 
        const [limit , setLimit] = useState(10); 
        const [resetKey, setResetKey] = useState(false); 
      
        const [isModalVisible, setIsModalVisible] = useState(false);
        const [currentItem, setCurrentItem] = useState(null);
        const [form] = Form.useForm();

        
  const handleAdd = () => {
    setCurrentItem(null);
    form.resetFields();
    setIsModalVisible(true);
  };


   const handleOk = async () => {
     try {
       // will resolve only if every rule passes
       const values = await form.validateFields();
       
         const transformedData = {
       ...values,
       status: values.status ? 'Active' : 'Inactive',
       cap: Number(values.cap), // optional: convert string to number
     };

     console.log('✅ Valid form data:', transformedData);
       let res 
  
 
         if (currentItem) {
               // Update
                res  = await  updateBonusTxnCap({id:currentItem._id , data:transformedData})
              
             } else {
               // Add new
               res = await addBonusTxnCap(transformedData)
             }
 
             if(res?.error === false)
                 {
                  setIsModalVisible(false);
                  message.success(res?.message);
                  setResetKey(prev => !prev); 
                 }
                 else {
                  message.error(res?.message);
                 }    
   
       // ...continue (API call, close modal, etc.)
     } catch (errorInfo) {
       // errorInfo = { values, errorFields, outOfDate }
       console.log('❌ Validation failed:', errorInfo);
   
       // If you want to scroll to first error:
       // form.scrollToField(errorInfo.errorFields[0].name);
     } finally {
       setLoading(false);
     }
   };
   
 
     const handleDelete = async (id) => {
       setLoading(true);
       // deleteTransactionType()
       try {
        let res  =  await deleteBonusTxnCap(id)
        if(res?.error === false)
         {
          message.success(res?.message);
          setResetKey(prev => !prev); 
         }
         else {
          message.error(res?.message);
         }
      
         
       } catch (error) {
        
       }
       setLoading(false);
     };
 
 
     // ✅ Fetch data function
     const fetchData = async () => {
       let body = {
         page:pageNo,
         limit:limit
       }
       // setLoading(true);
       try {
         const response = await getBonusTxnCap(body)
         console.log(response)
         setData(response.data || []);
         setTotalData(response?.data?.length || 0); // ✅ update total count
       } catch (error) {
         // message.error('Failed to fetch data');
       }
       // setLoading(false);
     };
   
     // ✅ On mount & when resetKey OR pageNo changes
     useEffect(() => {
       fetchData();
     }, [resetKey, pageNo]);


     const handleEdit = (item) => {
  setCurrentItem(item);
  form.setFieldsValue({
    cap: item.cap,
    status: item.status === 'Active', // convert "Active"/"Inactive" to boolean
  });
  setIsModalVisible(true);
};
  
  return (
    <>
      <Breadcrumbs breadCrumbsTitle={breadCrumbsTitle} />
          {loading && <Loader />}
           <div className="row m-4">
                  <div className="col-xl-12">
                    <div className="card">
                      <div className="card-body p-0">
                        <div className="table-responsive active-projects style-1">
                          <div className="tbl-caption d-flex justify-content-between align-items-center">
                            <h4 className="heading mb-0">Transaction Cap List</h4>
                            {/* <button type="button" className="btn btn-secondary btn-sm" onClick={handleAdd}>
                              Add Transaction Type
                            </button> */}
                            <Button type="primary" size="small" onClick={handleAdd}>
                            + Add New Cap
                          </Button>
                          </div>
                          <table className="table">
                            <thead>
                              <tr>
                                <th>Serial Number</th>
                                <th>Transaction Cap</th>
                                <th>Status</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {data?.length > 0 ? (
                                data?.map((item , index) => (
                                  <tr key={item._id}>
                                     <td>{index+1}</td>
                                    <td>{item.cap}</td>
                                    <td>
                                      <span
              className={`badge ${
                item.status === 'Active' ? 'bg-success' : 'bg-danger'
              }`}
            >
              {item.status}
            </span>
                                    </td>
                                    <td>
                                      <div className="d-flex">
                                        <button
                                          onClick={() => handleEdit(item)}
                                          className="btn btn-primary btn-xs sharp me-2"
                                        >
                                          <i className="fa fa-pencil" />
                                        </button>
                                        <Popconfirm
                                          title="Delete transaction cap?"
                                          onConfirm={() => handleDelete(item._id)}
                                          okText="Yes"
                                          cancelText="No"
                                        >
                                          <button className="btn btn-danger btn-xs sharp">
                                            <i className="fa fa-trash" />
                                          </button>
                                        </Popconfirm>
                                      </div>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="3" className="text-center">
                                    No data found.
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                          <div className="d-flex justify-content-between align-items-center p-2">
                            <div>Total {totalData} entries</div>
                            <Pagination
                              current={pageNo}
                              total={totalData}
                              pageSize={limit}
                              onChange={(page) => setPageNo(page)} // ✅ update pageNo state
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

           <Modal
                  title={currentItem ? 'Update Transaction Cap' : 'Add New Transaction Cap'}
                  open={isModalVisible}
                  onOk={handleOk}
                  onCancel={() => setIsModalVisible(false)}
                  okText={currentItem ? 'Update' : 'Add'}
                >
                  <Form form={form} layout="vertical">
                  <Form.Item
  name="cap"
  label="Transaction cap"
  rules={[
    {
      required: true,
      message: 'Please input your transaction cap.',
    },
    {
      pattern: /^\d+$/,
      message: 'transaction cap must contain digits only',
    },
  ]}
>
  <Input
    inputMode="numeric"          // better mobile keyboard
    maxLength={18}               // optional, e.g., max 18 digits
    onKeyPress={(e) => {
      if (!/[0-9]/.test(e.key)) {
        e.preventDefault();      // blocks non-numeric characters
      }
    }}
    placeholder="Enter transaction cap"
  />
</Form.Item>


                    <Form.Item
            name="status"
            label="Status"
            valuePropName="checked"
            style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}
          >
            <Switch
              checkedChildren="Active"
              unCheckedChildren="Inactive"
              className="custom-switch"
            />
          </Form.Item>
          
                  </Form>
                </Modal>      
    
    </>
  )
}

export default BonusTranactionCap


